import {
    axiosRequest,
    AxiosWrapper,
    ApiRequestOptions,
    ApiResponse,
    ApiRequestRoutingFunction,
} from '@web-chat-core/toolkit/src/api3';
import { getAppServerApiClient } from 'api/clients/apiClients';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function getDomainAxiosWrapper(domainName?: string, options?: ApiRequestOptions): AxiosWrapper {
    return getAppServerApiClient().getAxiosWrapper();
}

/**
 * Вызывается из сгенерированных сервисов.
 * @param domainName Домен API
 * @param options Дополнительные опции
 */
export const request: ApiRequestRoutingFunction = <T>(
    domainName: string,
    options: ApiRequestOptions,
): Promise<ApiResponse<T>> => {
    const axiosWrapper = getDomainAxiosWrapper(domainName, options);

    return axiosRequest<T>(domainName, options, axiosWrapper);
};
